import { fireQuickErrorToast } from '../../../../../webmodule-common/other/toast-away';
import { LangFabricationPurchaseOrder } from '../../../../../localization/scripts/fabrication-purchase-orders/views/fabrication-purchase-order-lang';
import {
  v6Config,
  v6SupportsVersion,
  v6VersionMap
} from '../../../../../webmodule-common/interop/interfaces/v6-config';
import { versionGreaterThanOrEqual } from '../../../../../webmodule-common/other/version-helper';

// create-fabrication-supplier-quote and the fabrication optimizer first shipped at this macro version.
const requiredFabricationMacroVersion = [13, 1, 13] as const;

// The finish/length pickers call V6 COM surface (Extrusion/Gasket.FinishColors +
// Extrusion.SuppliedLengthTypes) that ships with macro 13.1.9 / frameconfig v3.0.4 (see
// hasFabricationResourceFinishes in v6VersionMap). But building an ad-hoc PO is only worth it if the
// supplier can then optimize and issue it, and both require macro 13.1.13 - so gating on the finish
// surface alone let the user build an order that only failed later, at optimize/issue time. Gate on
// the higher bar: the loaded frameconfig engine AND the supplier's macro version.
export function isAdHocPickersSupported(frameConfigSupported: boolean, supplierMacroVersion: string): boolean {
  return frameConfigSupported && versionGreaterThanOrEqual(supplierMacroVersion, ...requiredFabricationMacroVersion);
}

// Gate the whole add flow up front: toast and bail before the resource-family picker rather than
// dead-ending mid-flow (older frameconfig returns empty/fails the finish surface) or letting the user
// build a PO the supplier's V6 is too old to optimize or issue.
export function adHocPickersSupported(supplierId: string): boolean {
  let supported = false;
  try {
    supported = isAdHocPickersSupported(
      // The gasket length and fill dimensions are parsed through the frameconfig too.
      v6SupportsVersion(v6VersionMap.hasFabricationResourceFinishes) &&
        v6SupportsVersion(v6VersionMap.hasMeasurementParsing),
      v6Config().getSupplier(supplierId).version
    );
  } catch {
    // getSupplier throws when suppliers are not loaded or the id is unknown (e.g. the PO's supplier
    // was later unlinked from the branch). This runs synchronously from a menu-icon handler, so an
    // uncaught throw becomes an unhandled rejection; leaving `supported` false falls through to the
    // toast instead.
  }
  if (!supported) fireQuickErrorToast(LangFabricationPurchaseOrder.adHocItemsUnsupported());
  return supported;
}
